import CurriculumSummary from './CurriculumSummary';

export default CurriculumSummary;
